<template>
    <div class="flex-fill">
        <div>
            <img class="pr-2" src="@/assets/svg/menu-dddddd.svg">
            <img
                id="go-back"
                class="pr-2"
                src="@/assets/svg/corner-up-left-dddddd.svg"
            >
            <img src="@/assets/svg/chervron-right-dddddd.svg">
        </div>
        {{ showLevel }}
        {{ slide }}
        <div class="services-menu mt-3 pb-3 pr-1 sidemenu">
            <ul class="list-group text-uppercase slide main current"
                :style="slide"
                v-if="items.length"
            >
                <test-navigation-list-item
                    v-for="(item, index) in items"
                    :key="index + 0"
                    :item="item"
                    :level="nextLevel"
                    :showLevel="showLevel"
                    :index="index"
                    @next-level="setScrollLevel"
                ></test-navigation-list-item>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      scrollLevel: 0,
      nextLevel: 1,
      showLevel: null,
      slide: { transform: `translate(0%)` }
    }
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  watch: {
    scrollLevel () {
      this.slide = { transform: `translate(${this.scrollLevel * -100}%)` }
    },
    '$route' (to) {
      let path = this.findPath('path', to.path)
      if (this.$_.isEmpty(path)) {
        return false
      }
      if (typeof path.j === 'undefined') {
        this.showLevel = path.i
      } else {
        this.showLevel = path.i + '-' + path.j
      }
    }
  },
  methods: {
    setScrollLevel (level) {
      this.scrollLevel = level
    },
    findPath (attr, value) {
      let path = {}
      for (let i = 0; i < this.items.length; i += 1) {
        if (this.items[i][attr] === value) {
          path.i = i
        }
        if (this.items[i].children && this.items[i].children.length) {
          for (let j = 0; j < this.items[i].children.length; j += 1) {
            if (this.items[i].children[j][attr] === value) {
              path.i = i
              path.j = j
            }
          }
        }
      }
      return path
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/test/Navigation.vue